import { render, staticRenderFns } from "./DlgMemberNew.vue?vue&type=template&id=90ca9c56&scoped=true"
import script from "./DlgMemberNew.vue?vue&type=script&lang=js"
export * from "./DlgMemberNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ca9c56",
  null
  
)

export default component.exports